import { loadResponseSchema } from "../../schemas/bis";
import { fetchApi } from "./internal";

export const load = {
	forSeason: (season?: number) => {
		const query = new URLSearchParams();
		if (season) query.set("season", String(season));
		const qs = query.toString();
		return fetchApi(`/load${qs ? `?${qs}` : ""}`, loadResponseSchema);
	},
};
